import React from 'react';
import { LoadingModal as LoadingModalUI } from '@jagad/ui';
import type { LoadingModalProps as LoadingModalUIProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

export type LoadingModalProps = Omit<LoadingModalUIProps, 'defaultMessage'> & {
  defaultMessage?: string;
};

export const LoadingModal: React.FC<LoadingModalProps> = (props) => {
  const { t } = useTranslation();
  const defaultMessage = props.defaultMessage ?? t('components.loadingModal.defaultMessage');

  return <LoadingModalUI {...props} defaultMessage={defaultMessage} />;
};

LoadingModal.displayName = 'LoadingModal';

export default LoadingModal;
